import HeadRow from './component';

export default HeadRow;
